"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compProps', 'skin'], function (_a) {
    var compProps = _a.compProps, skin = _a.skin;
    return {
        skin: skin,
        hasShadowLayer: true,
        currentSlideIndex: 0,
        transitionDuration: compProps.transDuration * 1000,
        transition: compProps.transition,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var transDuration = compProps.transDuration;
    return {
        height: 'auto',
        '--transition-duration': transDuration * 1000 + "ms",
        '--slides-overflow': 'visible',
        '--nav-dot-section-display': 'none',
        '--nav-button-display': 'none',
    };
});
//# sourceMappingURL=StateBox.js.map